var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"monitoringMain",attrs:{"data-open":_vm.open}},[_c('button',{attrs:{"data":_vm.open},on:{"click":_vm.openClose}},[_vm._v(_vm._s(_vm.title))]),_c('server'),_c('users'),_c('logs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }